window.openErrorModal = function openErrorModal(message) {
    if (document.getElementById('error-modal')) return;
    const modal = document.createElement('div');
    modal.id = 'error-modal';
    modal.className =
        'fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 animate-fade-in-up';
    modal.onclick = (e) => {
        if (e.target === modal) document.body.removeChild(modal);
    };

    const content = document.createElement('div');
    content.className =
        'bg-[#111] border border-red-500/30 rounded-xl w-full max-w-md p-6 shadow-[0_0_30px_rgba(239,68,68,0.2)] flex flex-col items-center text-center relative';

    // Header / Icon
    const icon = document.createElement('div');
    icon.className = 'w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center mb-4 text-red-500';
    icon.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>';
    content.appendChild(icon);

    const title = document.createElement('h3');
    title.className = 'text-lg font-bold text-white mb-2 uppercase tracking-wide';
    title.innerText = 'Connection Error';
    content.appendChild(title);

    const text = document.createElement('p');
    text.className = 'text-gray-400 text-sm leading-relaxed mb-6';
    text.innerText = message;
    content.appendChild(text);

    const closeBtn = document.createElement('button');
    closeBtn.className =
        'w-full py-3 rounded-lg bg-red-600 hover:bg-red-500 text-white font-bold tracking-widest uppercase transition-all duration-300 shadow-[0_0_15px_rgba(220,38,38,0.4)]';
    closeBtn.innerText = 'DISMISS';
    closeBtn.onclick = () => document.body.removeChild(modal);
    content.appendChild(closeBtn);

    modal.appendChild(content);
    document.body.appendChild(modal);
};

window.openMeetingModal = function openMeetingModal(overrideUrl) {
    if (document.getElementById('meeting-modal')) return;

    const calendarUrl = overrideUrl || 'https://cal.com/admin-enterprise-ai/onboarding?embed=true';
    const isOnboarding = !!overrideUrl;

    const modal = document.createElement('div');
    modal.id = 'meeting-modal';
    modal.className = 'fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
    modal.onclick = (e) => {
        if (e.target === modal) document.body.removeChild(modal);
    };

    // Content Container
    const content = document.createElement('div');
    content.className =
        'bg-[#111] rounded-xl w-full max-w-4xl overflow-hidden relative shadow-2xl flex flex-col border border-white/10';

    // --- Header ---
    const header = document.createElement('div');
    header.className = 'flex justify-between items-center p-4 bg-black/50 border-b border-white/10';

    const title = document.createElement('span');
    title.className = 'text-white font-medium text-sm tracking-wide uppercase';
    title.innerText = 'Book an Appointment';
    header.appendChild(title);

    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '&times;';
    closeBtn.className = 'text-gray-400 hover:text-white text-2xl font-bold px-2 leading-none transition-colors';
    closeBtn.onclick = () => document.body.removeChild(modal);

    header.appendChild(closeBtn);
    content.appendChild(header);

    // --- Section A: Consent Gate ---
    const consentSection = document.createElement('div');
    consentSection.id = 'consent-gate';
    consentSection.className = 'p-8 text-center flex flex-col items-center justify-center min-h-[400px]';
    consentSection.innerHTML = `
    <h2 class="text-2xl font-bold text-white mb-4">${isOnboarding ? 'Schedule Your Onboarding' : 'Book Your Sales Demo'}</h2>
    <p class="text-gray-300 mb-8 max-w-md">${isOnboarding ? 'Please confirm your preferences to schedule your technical setup call.' : 'Please confirm your communication preferences to access the real-time calendar.'}</p>

    <div class="flex items-start gap-4 max-w-lg mx-auto bg-white/5 p-6 rounded-lg border border-white/10 text-left">
        <input type="checkbox" id="sms-consent-check" class="mt-1 w-5 h-5 rounded border-gray-600 bg-gray-700 text-blue-500 focus:ring-blue-500 focus:ring-offset-gray-900 cursor-pointer">
        <label for="sms-consent-check" class="text-sm text-gray-400 leading-relaxed cursor-pointer">
            By checking this box, you agree to receive appointment confirmations, reminders, and feedback requests from Enterprise AI at the phone number provided. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe or HELP for help. View our <a href="terms.html" class="underline hover:text-white">Terms</a> and <a href="privacy.html" class="underline hover:text-white">Privacy Policy</a>.
        </label>
    </div>

    <button id="consent-continue-btn" disabled class="mt-8 px-8 py-3 rounded-full font-medium transition-all duration-300 uppercase tracking-wider text-sm bg-gray-800 text-gray-500 cursor-not-allowed border border-transparent">
        Continue to Calendar
    </button>
`;
    content.appendChild(consentSection);

    // --- Section B: Cal.com Calendar Iframe ---
    const calendarSection = document.createElement('div');
    calendarSection.id = 'calendar-view';
    calendarSection.className = 'hidden w-full bg-white';
    calendarSection.innerHTML = `
        <iframe src="${calendarUrl}" width="100%" height="720" frameborder="0" loading="lazy" style="min-height: 700px; border-radius: 8px;"></iframe>
    `;
    content.appendChild(calendarSection);

    modal.appendChild(content);
    document.body.appendChild(modal);

    // --- Logic ---
    const checkbox = document.getElementById('sms-consent-check');
    const btn = document.getElementById('consent-continue-btn');
    const gate = document.getElementById('consent-gate');
    const calendar = document.getElementById('calendar-view');

    checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
            btn.disabled = false;
            btn.className =
                'mt-8 px-8 py-3 rounded-full font-medium transition-all duration-300 uppercase tracking-wider text-sm bg-white text-black hover:scale-105 cursor-pointer border border-white';
        } else {
            btn.disabled = true;
            btn.className =
                'mt-8 px-8 py-3 rounded-full font-medium transition-all duration-300 uppercase tracking-wider text-sm bg-gray-800 text-gray-500 cursor-not-allowed border border-transparent';
        }
    });

    btn.addEventListener('click', () => {
        gate.classList.add('hidden');
        calendar.classList.remove('hidden');
    });

    // Define the event listener function for Cal.com
    const handleCalMessage = (event) => {
        // Cal.com sends messages with the type property, e.g. type: 'linkReady', 'bookingSuccessful'
        if (event.data && typeof event.data === 'object') {
            if (event.data.type === 'cal:bookingSuccessful' || event.data.action === 'bookingSuccessful') {
                if (isOnboarding) {
                    window.location.href = 'dashboard.html';
                } else {
                    // Try to get email if available in cal.com payload
                    try {
                        const email =
                            event.data.payload?.attendees?.[0]?.email || event.data.detail?.attendees?.[0]?.email;
                        if (email) {
                            localStorage.setItem('questionnaire_email', email);
                        }
                    } catch (e) {
                        console.warn('Could not extract email from Cal.com payload', e);
                    }
                    window.location.href = 'questionnaire.html';
                }
            }
        }
    };

    // Listen for Cal.com meeting booking success
    window.addEventListener('message', handleCalMessage);

    // Cleanup function
    const closeModal = () => {
        window.removeEventListener('message', handleCalMessage);
        document.body.removeChild(modal);
    };

    modal.onclick = (e) => {
        if (e.target === modal) closeModal();
    };

    closeBtn.onclick = closeModal;
};
